"use strict";
import "../app/vendor";
import "../app/accounts_payable";
import { setupHoneybadger } from "../app/honeybadger";
import { Elm } from "../elm/accounts-payable/src/EmbeddedComponents.elm";
setupHoneybadger("accounts-payable");
window.Elm = window.Elm || {};
window.Elm.EmbeddedComponents = Elm.EmbeddedComponents;
